import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../services/i18nService';

class ReloadPageAlert extends React.Component {
    static propTypes = {
        extraClasses: PropTypes.string,
        id: PropTypes.string,
        styles: PropTypes.object,
    };

    createCaptionHtml = () => {
        return { __html: t('alert.wrongToken.message') };
    };

    render() {
        const { extraClasses, id, styles } = this.props;
        return (
            <div key={id} className={`${extraClasses} reloadPageAlertWrapper`} id={id} style={styles} role="alertdialog">
                <h3 className="alertTitle">
                    {t('alert.wrongToken.title')}
                </h3>
                <p className="alertContent" dangerouslySetInnerHTML={this.createCaptionHtml()} />
            </div>
        );
    }
}

export default ReloadPageAlert;
